export enum ConclusaoParecer{
    CONTINUAR = "S",
	NAO_CONTINUAR = "N"
}